import { Component, OnChanges, OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef} from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {DemoService} from './../../../demo.service';
import {Routes, RouterModule, Router} from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
// Notifications
import { HotToastService } from '@ngneat/hot-toast';
import { JobTypeDocument } from './../../../shared/models/jobTypeDocument.model';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BillingTask } from './../../../shared/models/billingTask.model';


import {BehaviorSubject, Observable, Subject} from 'rxjs';

import { Subscription } from 'rxjs';



import { SubjectInvoiceItem } from './../../../shared/models/subjectInvoiceItem.model';
import { GlobalFunctionsService } from './../../../services/global-functions.service';

@Component({
  selector: 'app-invoice-item-row-form-widget',
  templateUrl: './invoice-item-row-form-widget.component.html',
  styleUrls: ['./invoice-item-row-form-widget.component.css']
})
export class InvoiceItemRowFormWidgetComponent implements OnInit, OnChanges {

  @Input() list_item_id;
//  @Input() row_data: Observable<any=[]>;
 @Input() row_data: any = [];
 @Input() row_index: number;
@Input() single_row;
@Input() invoice_status_var: 1; // default to draft

  row_items: any;
  invoice_item_model: SubjectInvoiceItem;
  myob_account_codes: any;
  myob_tax_codes: any;

// run this from parent component
@Output('doCalculations') doCalculations: EventEmitter<any> = new EventEmitter();
  text: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;


  constructor(
    private http: HttpClient,
    private _demoService: DemoService,
    private route: ActivatedRoute,
    private router: Router,
    public toastr: HotToastService,
    vcr: ViewContainerRef,
   
    private modalService: BsModalService, viewRef: ViewContainerRef,
    public gfunc: GlobalFunctionsService
  ) {


 // Set and Access login Session Variables
 this.gfunc.setLoginSessionVars(); // set in a global function file
 this.sessionUserId = this.gfunc.currentUserVAR.user_id;
 this.sessionUsername = this.gfunc.currentUserVAR.username;
 this.sessionBrandId = this.gfunc.currentUserVAR.brand_id;

      // need to add this as routes does not work globally
      this.all_router_details = this.router.url;
      this.gfunc.current_base_route = this.router.url.substr(0, this.all_router_details.lastIndexOf('/'));
      // this.single_row = false;

   }



  ngOnInit() {

  }


  ngOnChanges(changes) {
    
    // load the drop downs
    this.getMyobAccountCodes();
    this.getMyobTaxCodes();

 //   this.row_data =  this.row_data.json();
 // this.row_items = this.row_data[0];
  


  // filters and returns the specific row of the array results
// this.row_items = this.row_data.filter((x:any)=>{ return x.booking_task_id === 1;  });

// this.row_items = Object.values(this.row_data).filter(list => list.booking_task_id === 1);

// this.row_items = Object['values'](this.row_data).map(x => x.booking_task_id === 1 );

// just gets the first row 0 of the array.
// this.row_data =  this.row_data.filter((value, i) => i === 0);

    if (changes.list_item_id) {

    }

  }

  hack(val) {
    return Array.from(val); // returns an array or an object
  }


  onChange(event: any) {
    this.text = event.target.value;
    console.log('New value = ' + event.target.value);
    // update totals if change in qty or fee. 
  this.row_data.total = this.row_data.billing_task_fee * this.row_data.qty;
 
 
 
  //  if tax update the full dollar amount and quanty
  // Upgrade for Nijo Test
  if(this.row_data.myob_tax_code_id == '1' || this.row_data.myob_tax_code_id == '4') {
    // if(this.row_data.myob_tax_code_id == '1') {
    this.row_data.tax = (this.row_data.billing_task_fee / (100 / 10)) * this.row_data.qty; // + GST
    // this.row_data.tax = this.row_data.tax.toFixed(2);
    let rounded_data_tax = Math.round((this.row_data.tax + Number.EPSILON) * 100) / 100;
    this.row_data.tax = rounded_data_tax;

    this.row_data.total = (this.row_data.billing_task_fee * this.row_data.qty) + this.row_data.tax; // + Gst
    // this.row_data.total - this.row_data.total.toFixed(2); // see if this fixes and rounds down the GST
    let rounded_data_total = Math.round((this.row_data.total + Number.EPSILON) * 100) / 100;
    this.row_data.total = rounded_data_total;

    // :: Correct Way of working out GST with all prices are NET value.
    // this.row_data.tax = (this.row_data.billing_task_fee / 11) * this.row_data.qty; // net totaal so gst is the total divided by 11
  }else{
    this.row_data.tax = 0;

  }

// 24 Accounting Fix
// Put into an else statement above worked -- might be the solutions for all errors. // 24
  // Upgrade For Nijo Test
  // if(this.row_data.myob_tax_code_id >= '2') {
    if(this.row_data.myob_tax_code_id != '1' && this.row_data.myob_tax_code_id != '4' ) {
    // this.row_data.tax = 0;
  }

// this needs to be in a loop and go through all the rows other wise tax code totals do not work correctly. // + GST?????

  // seemed to create errors + GST?????
// let  count_of_items = Object.keys(this.row_data).length;
//   // need to do a loop of subject_billing items (.length)
//   for(let i=0; i < count_of_items; i++) {
//     let itemData = this.row_data[i];

//     if(itemData[i].myob_tax_code_id == '1') {
//       this.row_data[i].tax = (itemData[i].billing_task_fee / (100 / 10)) * itemData[i].qty;
//     }
//     if(itemData[i].myob_tax_code_id == '2') {
//       this.row_data[i].tax = 0;
//     }
//   } // end for loop of count array




// tax total?

};

  getMyobAccountCodes() {
    this._demoService.getMyobAccountCodes().subscribe(
       data => { this.myob_account_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }
  
   getMyobTaxCodes() {
    this._demoService.getMyobTaxCodes().subscribe(
       data => { this.myob_tax_codes = data;
        let res = data[0];
      },
       err => console.error(err),
       // () => console.log('done loading Trace Types')
     );
   }






}
